export default __webpack_public_path__ + "static/media/chat_global.a8b83fd0.mp3";